export default {
  QUESTIONS_FETCHED: 'QUESTIONS_FETCHED',
  QUESTION_LOAD: 'QUESTION_LOAD',
  QUESTION_DETAIL: 'QUESTION_DETAIL',
};
